import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "./authorization";
import { hashBlob } from "./commitFiles";
import { zql } from "./generatedDrizzleSchema";
import {
  composeSkillMd,
  type StoredSkillFile,
  validateSkillBundle,
} from "./skills/spec";

export const SKILL_CHECK_INTERVAL_MS = 24 * 60 * 60_000;
export type SkillBundle = Record<string, StoredSkillFile>;

function serializeSkillBundle(files: SkillBundle): string {
  return JSON.stringify(
    Object.fromEntries(
      Object.keys(files)
        .sort()
        .map((path) => [
          path,
          {
            content: files[path]!.content,
            encoding: files[path]!.encoding,
          },
        ])
    )
  );
}

export function hashSkillBundle(files: SkillBundle) {
  return hashBlob(serializeSkillBundle(files));
}

export function skillBundleWithLocalName(
  files: SkillBundle,
  name: string
): SkillBundle {
  const parsed = validateSkillBundle(files);
  return {
    ...files,
    "SKILL.md": {
      encoding: "utf8",
      content: composeSkillMd({
        ...parsed,
        manifest: { ...parsed.manifest, name },
      }),
    },
  };
}

export async function assertSkillContentEditable(
  tx: Transaction,
  skillId: string
) {
  const installation = await tx.run(
    zql.skillGitInstallations.where("skillId", skillId).one()
  );
  if (installation?.autoUpdate || installation?.autoUpdateRequested) {
    throw userFacingError(
      "Turn off automatic updates before editing this skill’s files"
    );
  }
}
